export default __webpack_public_path__ + "static/media/curve1.10ac79ad.svg";